import { useState } from 'react';

const SocialShareBar = () => {
  const [showCopied, setShowCopied] = useState(false);
  const currentUrl = window.location.href;
  const shareText = 'Descubra a experiência transformadora da Carta do Eu Futuro';

  const handleCopyLink = () => {
    navigator.clipboard.writeText(currentUrl);
    setShowCopied(true);
    setTimeout(() => setShowCopied(false), 2000);
  };

  return (
    <div className="fixed left-6 top-1/2 -translate-y-1/2 z-50 hidden lg:block">
      <div className="flex flex-col gap-3 bg-luxury-dark/80 backdrop-blur-xl border border-gold-500/20 rounded-2xl p-3 shadow-2xl">
        {/* Instagram */}
        <a
          href="https://instagram.com/bia.holmes"
          target="_blank"
          rel="noopener noreferrer"
          className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-purple-500 via-pink-500 to-orange-500 text-white rounded-xl hover:scale-110 transition-all duration-300 hover:shadow-[0_0_20px_rgba(219,39,119,0.5)] cursor-pointer"
          title="Siga no Instagram @bia.holmes"
        >
          <i className="ri-instagram-line text-xl"></i>
        </a>

        {/* Facebook */}
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`}
          target="_blank"
          rel="noopener noreferrer"
          className="w-12 h-12 flex items-center justify-center bg-[#1877F2] text-white rounded-xl hover:scale-110 transition-all duration-300 hover:shadow-[0_0_20px_rgba(24,119,242,0.5)] cursor-pointer"
          title="Compartilhar no Facebook"
        >
          <i className="ri-facebook-fill text-xl"></i>
        </a>

        {/* Telegram */}
        <a
          href={`https://t.me/share/url?url=${encodeURIComponent(currentUrl)}&text=${encodeURIComponent(shareText)}`}
          target="_blank"
          rel="noopener noreferrer"
          className="w-12 h-12 flex items-center justify-center bg-[#0088cc] text-white rounded-xl hover:scale-110 transition-all duration-300 hover:shadow-[0_0_20px_rgba(0,136,204,0.5)] cursor-pointer"
          title="Compartilhar no Telegram"
        >
          <i className="ri-telegram-fill text-xl"></i>
        </a>

        {/* Copiar Link */}
        <button
          onClick={handleCopyLink}
          className="w-12 h-12 flex items-center justify-center bg-gold-500 text-luxury-black rounded-xl hover:scale-110 transition-all duration-300 hover:shadow-[0_0_20px_rgba(201,168,76,0.5)] cursor-pointer relative"
          title="Copiar link"
        >
          <i className="ri-link text-xl"></i>
          {showCopied && (
            <div className="absolute -right-32 bg-gold-500 text-luxury-black px-3 py-1.5 rounded-lg text-xs font-['Montserrat'] font-semibold whitespace-nowrap">
              Link copiado!
            </div>
          )}
        </button>
      </div>
    </div>
  );
};

export default SocialShareBar;
